import { buildQueryParams, GENERIC_HEADERS } from '../constants/requests.constants';
const SELECTED_FIT_KEY = "selectedFit";
const BASE_URL = '/a/myaccount/customers/fits/';
export async function getFits(customerId, hash, associateId) {
    const response = await fetch(`${BASE_URL}${buildQueryParams(customerId, hash, associateId)}`, { method: 'GET', headers: GENERIC_HEADERS });
    if (!response.ok) {
        throw new Error('Error getting fits.');
    }
    else {
        return await response.json();
    }
}
export async function createFit(customerId, hash, associateId, fitDto) {
    const response = await fetch(`${BASE_URL}${buildQueryParams(customerId, hash, associateId)}`, { method: 'POST', headers: GENERIC_HEADERS, body: JSON.stringify(fitDto) });
    if (!response.ok) {
        const json = await response.json();
        if (json && json.errors && json.errors.length) {
            throw new Error(json.errors[0]);
        }
        else {
            throw new Error('Error creating fit.');
        }
    }
    else {
        return await response.json();
    }
}
export async function updateFit(customerId, hash, associateId, fitDto) {
    const response = await fetch(`${BASE_URL}${fitDto.id}${buildQueryParams(customerId, hash, associateId)}`, { method: 'PUT', headers: GENERIC_HEADERS, body: JSON.stringify(fitDto) });
    if (!response.ok) {
        throw new Error('Error updating fit.');
    }
    else {
        return await response.json();
    }
}
export async function deleteFit(customerId, hash, associateId, fitId) {
    const response = await fetch(`${BASE_URL}${fitId}${buildQueryParams(customerId, hash, associateId)}`, { method: 'DELETE', headers: GENERIC_HEADERS });
    if (!response.ok) {
        throw new Error('Error deleting fit.');
    }
}
export async function sendFitEmail(customerId, hash, associateId, emailDto) {
    const response = await fetch(`${BASE_URL}sendFit${buildQueryParams(customerId, hash, associateId)}`, { method: 'POST', headers: GENERIC_HEADERS, body: JSON.stringify(emailDto) });
    if (!response.ok) {
        throw new Error('Error sending fit.');
    }
}
export function setSelectedFit(id, size, fit) {
    try {
        sessionStorage.setItem(SELECTED_FIT_KEY, JSON.stringify({ id, fit, size }));
    }
    catch (e) {
        console.error(e);
    }
}
export function getSelectedFit() {
    const data = sessionStorage.getItem(SELECTED_FIT_KEY);
    return data ? JSON.parse(data) : null;
}
export function removeSelectedFit() {
    sessionStorage.removeItem(SELECTED_FIT_KEY);
}
